<template>
  <div class="h-100 mh-100">
    <XYBubblesCanvas>
      <!-- The widgets slot iterates over all possible widget positions, rendering a widgets container
        in each position. For each iteration the slot provides the current position so the parent
        can conditionally render components into that position -->
      <template #widgets="{ widgetsContainerPosition }">
        <BubblesLegendsAccordion v-if="bubblesLegendsPosition === widgetsContainerPosition" />
      </template>
    </XYBubblesCanvas>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import XYBubblesCanvas from '@/components/public/Visualisations/XYBubbles/XYBubblesCanvas.vue'
import FilterBubblesUI from '@/components/public/FilterByCategory/FilterBubblesUI.vue'
import BubblesLegendsAccordion from '@/components/public/BubblesLegendsAccordion.vue'

import { LegendPositions } from '@/types'

const components = {
  XYBubblesCanvas,
  FilterBubblesUI,
  BubblesLegendsAccordion,
}

@Component({ components })
export default class BubblesV2 extends Vue {
  TOP_LEFT = LegendPositions.TOP_LEFT
  BOTTOM_LEFT = LegendPositions.BOTTOM_LEFT
  BOTTOM_RIGHT = LegendPositions.BOTTOM_RIGHT

  get bubblesLegendsPosition() {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.bubblesLegends
      .legendPosition
  }
}
</script>
